import { useTranslation } from "react-i18next";
import PdfConvertingBadge from "./PdfConvertingBadge";

type PdfCardThumbnailProps = {
  thumbnailUrl?: string | null;
  fileName?: string;
  isConverting: boolean;
  onPlay: () => void;
};

export default function PdfCardThumbnail({
  thumbnailUrl,
  fileName,
  isConverting,
  onPlay,
}: PdfCardThumbnailProps) {
  const { t } = useTranslation();
  return (
    <div className="relative bg-gradient-to-br from-indigo-100 to-purple-100 dark:from-indigo-500/15 dark:to-purple-500/15">
      {isConverting ? (
        <PdfConvertingBadge />
      ) : (
        <div className="flex h-40 items-center justify-center sm:h-44">
          {thumbnailUrl ? (
            <img
              src={thumbnailUrl}
              alt={fileName ?? ""}
              className="h-full w-full object-cover"
            />
          ) : (
            <div className="flex items-center justify-center py-6">
              <div className="text-center">
                <i className="ri-image-line mb-2 text-4xl text-muted-foreground" aria-hidden="true" />
                <p className="text-xs text-muted-foreground">
                  {t("dashboard.no_image")}
                </p>
              </div>
            </div>
          )}
        </div>
      )}

      <button
        type="button"
        onClick={onPlay}
        disabled={isConverting}
        aria-label={t("common.presentation")}
        className="group absolute inset-0 flex cursor-pointer items-center justify-center bg-black/0 transition-all hover:bg-black/30 focus-visible:bg-black/30 focus-visible:outline-none disabled:cursor-not-allowed disabled:hover:bg-transparent"
      >
        <span className="flex h-10 w-10 -translate-y-0 items-center justify-center rounded-full bg-white/90 opacity-0 shadow-lg transition-all group-hover:scale-110 group-hover:bg-white group-hover:opacity-100 group-focus-visible:opacity-100">
          <i className="ri-play-fill ml-0.5 text-xl text-indigo-600" aria-hidden="true" />
        </span>
      </button>
    </div>
  );
}
